import { css } from 'aphrodite';
import { useAuth } from 'react-oidc-context';
import { Button } from 'semantic-ui-react';

import { validate } from '../../../application/security/auth';
import stylesCommons from '../../StylesCommons';
import HoverablePopup from '../HoverablePopup';

interface permissionAwareProps {
    requiredPermission: string;
    buttonText: string;
    onClick: () => void;
    button?: boolean;
    invalid?: boolean;
    disabled?: boolean;
}

export default (props: permissionAwareProps) => {
    return validate(props.requiredPermission, useAuth())
        ? getCustomOrDefault(props)
        : getDisabledButton(props);
};

const getCustomOrDefault = (props: permissionAwareProps) => {
    return props.button ? (
        props.button
    ) : (
        <Button
            type="submit"
            className={css(stylesCommons.buttonPrimary)}
            disabled={props.invalid || props.disabled}
            onClick={props.onClick}>
            {props.buttonText}
        </Button>
    );
};

const getDisabledButton = (props: permissionAwareProps) => {
    return (
        <HoverablePopup
            flowing
            trigger={
                <span>
                    <Button className={css(stylesCommons.buttonPrimary)} disabled={true}>
                        {props.buttonText}
                    </Button>
                </span>
            }>
            <p> You don&apot have required permission: {props.requiredPermission}</p>
        </HoverablePopup>
    );
};
